import React, { useState } from 'react';
import { apiService } from '../services/api';

const RequestAccountDeletion: React.FC = () => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSuccess(null);
    setError(null);
    setLoading(true);
    try {
      if (!email && !phone) {
        setError('Please enter your email or phone number.');
        setLoading(false);
        return;
      }
      await apiService.requestDeleteAccount({ email: email || undefined, phone: phone || undefined });
      setSuccess('Your account deletion request has been processed.');
      setEmail('');
      setPhone('');
    } catch (err: any) {
      setError(err.message || 'Failed to request account deletion.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4 text-center">Request Account Deletion</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block mb-1 font-medium">Email</label>
            <input
              type="email"
              className="w-full border rounded px-3 py-2"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
          </div>
          {error && <div className="text-red-500 text-center">{error}</div>}
          {success && <div className="text-green-600 text-center">{success}</div>}
          <button
            type="submit"
            className="w-full bg-imola-primary text-white py-2 rounded font-semibold mt-2"
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Request Deletion'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RequestAccountDeletion;

export {}; 